<template>
  <div class="view pa24">
    <div class="d-flex justify-content-between">
      <div>
        {{ $t('article', 'activityTitle') }}：
        <el-input
          v-model="activityName"
          class="w200 mr10"
          :placeholder="$t('article', 'enterActivityName')"
        />
        
        {{ $t('article', 'selectTime') }}：
        <el-date-picker
          v-model="pickerValue"
          class="mr10"
          align="right"
          value-format="yyyy-MM-dd"
          type="daterange"
          :start-placeholder="$t('marketing', 'startDate')"
          :end-placeholder="$t('marketing', 'endDate')"
        />
        {{ $t('article', 'activityStatus') }}：
        <el-select class="mr20 w150" v-model="authsId" clearable>
          <el-option
            v-for="item in auths"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            {{ item.name }}
          </el-option>
        </el-select>
        <el-button type="primary" @click="queryVisitorsData">{{ $t('marketing', 'search') }}</el-button>
        <el-button @click="reset">{{ $t('common', 'reset') }}</el-button>
        
      </div>
        <el-button type="primary" @click="addActivity">+ {{ $t('article', 'createActivity') }}</el-button>
    </div>
    
  <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column prop="aeId" width="50" align="center" :label="$t('common', 'serialNumber')"> </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          width="200"
          :label="$t('article', 'activityTitle')"
          show-overflow-tooltip
        />
        <el-table-column prop="description" width="250" show-overflow-tooltip align="center" :label="$t('article', 'activityContent')" />
        <el-table-column prop="createdTime" width="250" show-overflow-tooltip align="center" :label="$t('article', 'activityTimeCycle')" >
          <template slot-scope="scope">
            {{ scope.row.createdTime + '-' +  scope.row.endTime  }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" :label="$t('article', 'activityStatus')">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? $t('article', 'notStarted') : scope.row.status == 2 ? $t('article', 'inProgress') : $t('article', 'ended') }}
          </template>
        </el-table-column>
        <el-table-column prop="userNum" align="center" :label="$t('article', 'registrationLimit')">
          <template slot-scope="scope">
            {{scope.row.userNum == 0 ? $t('article', 'unlimited') : scope.row.userNum}}
          </template>
        </el-table-column>
        <el-table-column prop="joinedNum" align="center" :label="$t('article', 'registeredCount')"/>
          
        <el-table-column prop="visitTime" align="center" :label="$t('article', 'activityPublishStatus')">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.isPutOn"
                :active-text="$t('article', 'publish')"
                :inactive-text="$t('article', 'unpublish')"
                @change="switchChange(scope.row)"
              >
              </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="visitTime" width="150" align="center" :label="$t('common', 'edit')">
          <template slot-scope="scope">
            <div class="d-flex">
              <p class="cred hover_pointer mr20" @click="deleteActivity(scope.row)">{{ $t('common', 'delete') }}</p>
              <p class="cA1 hover_pointer mr20" @click="editActivity(scope.row)">{{ $t('common', 'edit') }}</p>
              <p class="cblue hover_pointer" @click="toDetailPage(scope.row)">{{ $t('business', 'memberDetail') }}</p>
            </div>
            
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import {
  activityEventList,
  activityEventDelete,
  activityEventUpdate
} from "@/api/companyManage.js";
import { queryCompanyStaff } from "@/api/articleManagement";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      auths: [
        { id: 1, name: this.$t('article', 'notStarted') },
        { id: 2, name: this.$t('article', 'inProgress') },
        { id: 3, name: this.$t('article', 'ended') },
      ],
      authsId: "",
      activityName: "",
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryCompanyStaff();
    this.queryVisitorsData();
  },
  methods: {
    async queryCompanyStaff() {
      try {
        const result = await queryCompanyStaff({ companyId: 0 });
        this.staffs = result.data;
      } catch (error) {
        console.log(error);
      }
    },
    reset(){
      this.pickerValue = []
      this.activityName = ''
      this.authsId = ''
    },
    async queryVisitorsData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        status: this.authsId,
        userId: this.userId,
        name: this.activityName,
        startTime: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        endTime: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      try {
        this.loading = true;
        const result = await activityEventList(data);
        this.loading = false;
        const { total, list } = result?.data?.pageInfo;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+"秒";
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+"分"+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+"小时"+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVisitorsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVisitorsData();
    },
    addActivity(){
      this.$router.push('addActivity')
    },
    editActivity(item){
      this.$router.push('addActivity?aeId=' + item.aeId)
    },
    deleteActivity(item){
      this.$confirm(this.$t('article', 'deleteActivityConfirm'), this.$t('article', 'deleteActivity'), {
        confirmButtonText: this.$t('common', 'confirm'),
        cancelButtonText: this.$t('common', 'cancel'),
      }).then(() => {
        let data ={
          aeId:item.aeId,
        }
        activityEventDelete(data)
        .then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('article', 'successfullyCancelled')) 
            this.queryVisitorsData()
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common', 'cancelled')
        });          
      });
    },
    switchChange(item){
      console.log(item.isPutOn)
      let data = {
        isPutOn:item.isPutOn,
        aeId:item.aeId
      }
      activityEventUpdate(data)
      .then(res=>{
        if(res.code == 200){
          if(!item.isPutOn){
            this.$message.success(this.$t('article', 'unpublishSuccess')) 
          }else{
            this.$message.success(this.$t('article', 'publishSuccess'))
          }
          
          this.queryVisitorsData()
        }
      })
    },
    toDetailPage(item){
      this.$router.push('activityDetails?aeId=' + item.aeId)
    }
  },
};
</script>

<style lang="scss" scoped>
</style>